.form {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
}

.properties {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: .8rem;
}
